var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('member-detail-component',{attrs:{"member-type":'curationRequest',"memberKey":_vm.$route.params.mb_no}}),_c('item-list-component',{attrs:{"item-type":'curationRequest',"memberKey":_vm.UserInfo.mb_no}}),_c('curation-request-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }